/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

export const dialogTitleStyles = {
  fontSize: "18px",
  fontWeight: 700,
  color: "#111827",
};

export const dialogHeaderStyles = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "20px 24px 0",
};

export const dialogIconTileStyles = {
  flexShrink: 0,
  width: 40,
  height: 40,
  borderRadius: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#eef0fb",
  color: "#4f46e5",
};

export const dialogSubtitleStyles = {
  fontSize: "14px",
  color: "#52525b",
  padding: "12px 24px 16px",
};

export const fieldLabelStyles = {
  display: "block",
  fontSize: "14px",
  fontWeight: 600,
  color: "#111827",
  mb: 0.75,
};

export const requiredMarkStyles = { color: "#b91c1c", ml: 0.25 };

export const optionalMarkStyles = { fontWeight: 400, color: "#6b7280" };

export const fieldInputStyles = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "14px",
    // Same hover/focus border as the report filters (selectBaseStyles); errors stay red.
    "&:not(.Mui-error):hover fieldset": { borderColor: "#2b4fb9" },
    "&:not(.Mui-error).Mui-focused fieldset": { borderColor: "#2b4fb9" },
  },
  "& .MuiFormHelperText-root": { mx: 0 },
};

export const helperRowStyles = {
  display: "flex",
  justifyContent: "space-between",
  gap: 2,
  fontSize: "12px",
};

export const helperCountStyles = { flexShrink: 0, color: "#6b7280" };

export const dialogActionsStyles = {
  padding: "16px 24px",
  borderTop: "1px solid #e5e7eb",
  justifyContent: "flex-end",
  gap: "12px",
};

export const primaryActionStyles = {
  padding: "6px 16px !important",
  "&.Mui-disabled": { backgroundColor: "#ebebeb", color: "#9e9e9e" },
};

export const cancelActionStyles = { textTransform: "none", borderRadius: "8px" };

export const loadedQueryChipStyles = {
  maxWidth: { xs: "100%", sm: 260 },
  height: "2.4rem",
  borderRadius: "4px",
  borderColor: "#2b4fb9",
  backgroundColor: "#eef2fb",
  color: "#2b4fb9",
  fontSize: "0.875rem",
  fontWeight: 600,
  "& .MuiChip-icon": { color: "#2b4fb9" },
  "& .MuiChip-label": { display: "flex", flexDirection: "column", minWidth: 0, lineHeight: 1.2 },
};

export const loadedQueryNameStyles = { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" };

export const loadedQueryModifiedStyles = { fontSize: "11px", fontWeight: 500, color: "#52525b" };

export const queryListStyles = {
  maxHeight: 360,
  overflowY: "auto",
  border: "1px solid #e5e7eb",
  borderRadius: "8px",
  mt: 2,
};

export const queryRowStyles = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  px: 2,
  py: 1.5,
  "&:not(:last-of-type)": { borderBottom: "1px solid #e5e7eb" },
};

export const queryNameStyles = {
  fontSize: "14px",
  fontWeight: 600,
  color: "#111827",
  overflowWrap: "anywhere",
};

export const queryDescriptionStyles = {
  fontSize: "13px",
  color: "#52525b",
  overflowWrap: "anywhere",
};

export const emptyStateStyles = {
  fontSize: "14px",
  color: "#52525b",
  textAlign: "center",
  px: 2,
  py: 4,
};
